












import { listFactory } from '@/main/pages/listFactory';
import { forceFileDownload, parseObj2Csv } from '@/main/utils/fileHelper';

import { NAME } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	methods: {
		async filterClick() {
			if (this.NationalAccount !== null && this.NationalAccount > 0) {
				this.startLoading();
				const data = await apiProvider.getDealerCPF(this.NationalAccount);
				const url = `data:text/csv;charset=utf-8,%EF%BB%BF",${encodeURIComponent(parseObj2Csv(data.data))}`;
				forceFileDownload(url);
				this.endLoading();
			}
		},
	},
});
